import {BaseContainerModel} from '../../base-container.model';
import {Bl_inv_stock_take_session_report_line_RowClass} from '../../../dbschema/bl_inv_stock_take_session_report_line.model';

export class StockTakeSessionGenerateReportModel extends BaseContainerModel{
    stock_take_session_report_lines: Bl_inv_stock_take_session_report_line_RowClass[] = [];
}
